import { SearchContentListItem } from "@/interfaces/pubmed.interface";
import { currentUserState } from "@/stores/common";
import { colorMatchIFRange } from "@/utils/color.util";
import { iff } from "@/utils/common.util";
import { firstCapitalize, shortUUID } from "@/utils/string.util";
import { Popover } from "antd";
import moment from "moment";
import Link from "next/link";
import React from "react";
import { useRecoilValue } from "recoil";
import styles from "../styles.module.less";
import JournalCard from "./JournalCard";
import PublishType from "./PublishType";

const { container, one, two, tag, nouser } = styles;

interface IProps {
  journal: SearchContentListItem["journal"];
  journalInfo: SearchContentListItem["journalInfo"];
  articleDate: SearchContentListItem["articleDate"];
  publicationTypes: SearchContentListItem["publicationTypes"];
  medlineJournalInfo: SearchContentListItem["medlineJournalInfo"];
  doi: string;
  pmid: string;
  dict: {
    title: string;
    nImpactFactor: string;
    publisherName: string;
    country: string;
    categories: string;
    meshes: string;
    cardTitle: string;
  };
}

const JournalDescripton: React.FC<IProps> = ({
  journal,
  journalInfo,
  articleDate,
  doi,
  pmid,
  publicationTypes,
  dict,
  medlineJournalInfo,
}) => {
  const des = [
    { label: dict.title, content: journal?.title?.toLowerCase() },
    { label: dict.nImpactFactor, content: journal?.nImpactFactor?.toString() },
    { label: dict.country, content: journal?.country?.toLowerCase() },
    {
      label: dict.publisherName,
      content: journal?.publisherName?.toLowerCase(),
    },
    {
      label: dict.categories,
      content: journal?.categories?.toLowerCase()?.split("|"),
    },
    {
      label: dict.meshes,
      content: journal?.meshes?.map((mesh) => mesh?.name?.toLowerCase()),
    },
  ];

  const currentUser = useRecoilValue(currentUserState);

  return (
    <div className={container}>
      {currentUser?.id ? (
        <>
          <Popover
            content={
              Object.values(journal).filter((j) => j && j !== "JournalEach")
                ?.length > 0 && <JournalCard des={des} />
            }
            title={
              <Link
                href="/navigator/journal/[id]"
                as={
                  journal?.id
                    ? `/navigator/journal/${shortUUID(journal?.id)}`
                    : "#"
                }
              >
                <a>{firstCapitalize(journal?.title)}</a>
              </Link>
            }
          >
            <span
              className={one}
              style={{
                border: `0.125rem solid ${colorMatchIFRange(
                  journal?.nImpactFactor
                )}`,
              }}
            >
              {medlineJournalInfo?.medlineTA ||
                journalInfo?.issoAbbrTitle ||
                journalInfo.title}
            </span>
          </Popover>
          <span
            className={two}
            style={{
              backgroundColor: `${colorMatchIFRange(journal?.nImpactFactor)}`,
            }}
          >
            {journal?.nImpactFactor || "Not Found"}
          </span>
        </>
      ) : (
        <span
          className={nouser}
          style={{
            border: `0.125rem solid ${colorMatchIFRange(
              journal?.nImpactFactor
            )}`,
          }}
        >
          {medlineJournalInfo?.medlineTA ||
            journalInfo?.issoAbbrTitle ||
            journalInfo.title}
        </span>
      )}

      <span className={tag}>
        {journalInfo.pubdate
          ? journalInfo.pubdate?.replace(/-/g, " ")
          : iff(
              articleDate,
              moment(articleDate, "YYYY-MM-DD").format("YYYY MMM D"),
              ""
            )}
      </span>
      <span className={tag}>
        Doi:{" "}
        <a
          href={`https://doi.org/${doi}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {doi}
        </a>
      </span>
      <span className={tag}>
        PMID:{" "}
        <a
          href={`https://pubmed.ncbi.nlm.nih.gov/${pmid}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {pmid}
        </a>
      </span>
      <PublishType arr={publicationTypes} />
    </div>
  );
};

export default JournalDescripton;
